module.exports = __webpack_public_path__ + "img/服务伙伴02.36b30892.png";